<template>
<div class="content">
  <el-row class="search">
    <el-col :span="6">
      <div class="grid-content">
      </div>
    </el-col>
    <el-col :span="12">
      <el-select v-model="params.cid" style="width:100%" size="mini" clearable>
        <el-option v-for="item in news.category" :value="item.id" :label="item.name" :key="item.id">{{item.name}}</el-option>
      </el-select>
    </el-col>

    <el-dialog :visible.sync="detail.show" center :destroy-on-close="true">
      <el-scrollbar style="height:500px">
        <div style="padding:15px">
          <div>
            <h3>{{detail.data.title}}</h3>
            <span style="margin-right: 5px">{{detail.data.name}}</span>
            <span style="margin-right: 5px">{{detail.data.createTime | formatDate}}</span>
            <span style="padding: 5px">
              <i class="el-icon-view"></i>
              {{detail.data.browseCount}}
            </span>
          </div>
          <br>
          <div class="" v-html="detail.data.content"></div>
          <div style="float: right" >
            <div class="updateTime"  v-if=" detail.data.updateTime != null" >
              <span class="time">更新时间:{{detail.data.updateTime|formatDate}}</span>
            </div>

            <div class="browseCount" >
              <span class="time">浏览次数:{{detail.data.browseCount}}</span>
            </div>

            <div class="categoryName"  >
              <span class="time"> 发布栏目:{{detail.data.categoryName}}</span>
            </div>
            <div class="categoryName"  v-if="detail.data.editor != null">
              <span class="time"> 编辑人:{{detail.data.editor}}</span>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
  </el-row>

  <el-row>
    <el-col :span="6">
      <div class="grid-content">
      </div>
    </el-col>

    <el-col :span="12">
      <el-table :data="news.list"  style="min-height:570px;" @row-click="openDetails" :row-style="{height:'35px'}" class="tableClass" size="medium">
        <el-table-column  label="" width=100>
          <template slot-scope="scope">
            <el-tag type="plain">{{scope.row.name}}</el-tag>

          </template>
        </el-table-column>

        <el-table-column prop="title" label="标题" width=600>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="dateFormat"label="时间" width=200>
        </el-table-column>
      </el-table>

      <el-pagination background layout="prev, pager, next" :total="news.total" :page-size="params.size" @current-change="handleCurrentChange" :current-page.sync="params.page"></el-pagination>

    </el-col>


  </el-row>


</div>
</template>

<script>
  import { getNewsCategory,getNewsById,getNews,addReadCount,OK,HOST} from '../../api/data.js'
  import moment from 'moment'
export default {
  name: 'News',
  data() {
    return {
      news: {
        list: [],
        category: [],
        total: 0
      },
      params: {
        cid: '', //默认全部
        page: 1,
        size: 10
      },
      detail: {
        show: false,
        data: {}
      }
    };
  },
  filters: {
    formatDate: function (value) {
      return moment(value).format('YYYY-MM-DD HH:mm')
    }

  },
  watch: {
    'params.cid': function(val){

       //console.log(val)
      this.getNews()
    },
    'params.page': function(val) {

      //console.log(val)
      this.getNews()
    }
  },
  mounted(){
    this.getNewsCategory()
    this.getNews()
  },

  methods: {
    //时间格式化
    dateFormat:function(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");

  },

    handleCurrentChange(val) {
      this.params.page = val
    },
    openDetails(val){
      this.detail.data = val
      this.detail.show = true
      this.addReadCount(this.detail.data.id)
    },
    addReadCount(id){
      let _this = this
      addReadCount(id).then(function (res) {
        if (res.data.flag == 'success') {
          _this.getNewsById(id)
        }
      }).catch(function (res) {
        console.log(res);
      })
    },
    getNewsById(id){
      let params = {
        category: '',
        page: 1,
        size: 10,
        id: id
      }
      // console.log(params)
      let _this = this
      getNewsById(params.category,params.page,params.size,params.id).then(function (res) {
        if (res.data.flag == 'success') {
          _this.detail.data = res.data.data.list[0]

          var str  =  _this.detail.data.content.replace(/<a [^>]*href=['"]([^'"]+)[^>]*>/gi, function (match,capture) {
           var newStr='<a  href="'+HOST+capture +'" download=""  />';
           return newStr;
         });

          str  =  str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match,capture) {
            var newStr='<img src="'+HOST+capture +'" height="450" width="450"  />';
            return newStr;
          });
          str  = str.replace(/<embed [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match,capture) {
            var newStr='<video src="'+HOST+capture +'" height="220" width:100% controls="controls"  ></video>';
            return newStr;
          });
          _this.detail.data.content = str


        }
      }).catch(function (res) {
        console.log(res);
      })

    },

    getNews() {
      let _this = this
      getNews(this.params.cid,this.params.page,this.params.size).then(function (res) {
        if (res.data.flag == 'success') {
          _this.news.list = res.data.data.list
          _this.news.total = res.data.data.total

        }
      }).catch(function (res) {
        console.log(res);
      })
    },
    getNewsCategory() {
      let _this = this
      getNewsCategory().then(function (res) {
        if (res.data.flag == 'success') {
          _this.news.category = res.data.data
        }
      }).catch(function (res) {
        console.log(res);
      })


    }
  }

}
</script>


<style scoped>
.form_border {
  border: 1px solid grey;
  padding: 5px;
  border-radius: 10px;
}

.content {
  /* background: #FBFBFB */
}
.tableClass{
  border-radius: 3px;
  box-shadow: 0 2px 10px 0 rgba(255, 255, 255, 0.5);
  padding-left: 5%;
  padding-right: 5%
}
</style>



// WEBPACK FOOTER //
// src/components/pc/News.vue